import enumeration, {TEnumerationValue} from '../../Shared/Util/enumeration';

const FocusableNodeType = enumeration([
    'GRID',
    'HORIZONTAL_LIST',
    'LEAF',
    'VERTICAL_LIST',
    'VIRTUAL_HORIZONTAL_LIST',
    'VIRTUAL_VERTICAL_LIST',
]);

type TFocusableNodeType = TEnumerationValue<typeof FocusableNodeType>;

export {FocusableNodeType as default, type TFocusableNodeType};
